import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "change-logs"
    }}>{`Change Logs`}</h1>
    <h2 {...{
      "id": "v148"
    }}>{`v1.4.8`}</h2>
    <pre><code parentName="pre" {...{}}>{`= 1.4.8 - August 8 2022 =

* [Fix] WordPress Latest Version Compatibility.
* [Feat] Booking and Rental System (WooCommerce) plugin support add.
`}</code></pre>
    <h2 {...{
      "id": "v147"
    }}>{`v1.4.7`}</h2>
    <pre><code parentName="pre" {...{}}>{`= 1.4.7 - May 10 2022 =

* [Fix] WordPress Latest Version Compatibility.
* [Fix] WooCommerce Latest Version Compatibility.
* [Fix] Update Starter Content.
`}</code></pre>
    <h2 {...{
      "id": "v146"
    }}>{`v1.4.6`}</h2>
    <pre><code parentName="pre" {...{}}>{`= 1.4.6 - Mar 4 2022 =

* [Fix] Remove accessibility-ready tag.
* [Fix] Starter content logo broken issue.
* [Fix] Header area search panel issue.
`}</code></pre>
    <h2 {...{
      "id": "v145"
    }}>{`v1.4.5`}</h2>
    <pre><code parentName="pre" {...{}}>{`= 1.4.5 - Feb 22 2022 =

* [Fix] php8 compatibility check.
`}</code></pre>
    <h2 {...{
      "id": "v144"
    }}>{`v1.4.4`}</h2>
    <pre><code parentName="pre" {...{}}>{`= 1.4.4 - Feb 18 2022 =

* [Fix] Starter content broken issue.
`}</code></pre>
    <h2 {...{
      "id": "v143"
    }}>{`v1.4.3`}</h2>
    <pre><code parentName="pre" {...{}}>{`= 1.4.3 - Feb 18 2022 =

* [Fix] Composer file name issue.
`}</code></pre>
    <h2 {...{
      "id": "v142"
    }}>{`v1.4.2`}</h2>
    <pre><code parentName="pre" {...{}}>{`= 1.4.2 - Feb 17 2022 =

* [Fix] Documentation update.
* [Fix] Language file update.
* [Feat] Homepage Gutenberg blocks support.
* [Feat] Starter content added.
* [Feat] Theme info related admin notice added.
* [Feat] Theme tour guide added in admin area.
`}</code></pre>
    <h2 {...{
      "id": "v141"
    }}>{`v1.4.1`}</h2>
    <pre><code parentName="pre" {...{}}>{`= Feb 09 2022 =

* [Fix] Category permalink issue.
* [Fix] Accessibility ready issue fix.
* [Fix] Mini-cart overlapping CSS issue.
* [Fix] Header overlapping in Category sidebar CSS issue.
* [Fix] Typogrpahy panel compatibility check & fix with Kirki plugin v4.0.20.
* [Perf] Product category query optimization for better performance.
* [Feat] Copyright site link customize options added.
* [Feat] Homepage product category customize option added.
`}</code></pre>
    <h2 {...{
      "id": "v14"
    }}>{`v1.4`}</h2>
    <pre><code parentName="pre" {...{}}>{`= Feb 04 2022 =

* Initial release.
`}</code></pre>
    <h1 {...{
      "id": "thank-you"
    }}>{`Thank You`}</h1>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      